import {
  getAttrs,
  parseAttributes
} from 'utils/index'

import {
  CREATE_PROJECT_STATE,
  DESTROY_PROJECT_STATE,

  SET_PROJECT_DEVICE,

  PUBLISH_PROJECT_REQUEST,
  PUBLISH_PROJECT_SUCCESS,
  PUBLISH_PROJECT_COMPLETE
} from 'actions/project'

export const initialState = {
  loading: true,
  notFound: false,

  project: null,

  device: 'desktop',

  hasUnsavedChanges: false,

  isPublishing: false,
  isPublishingSuccessful: false,

  isSaving: false,
  isSavingSuccessful: false,

  isBrowserOpen: false,
  isEditorOpen: false,

  components: [],

  page: null,

  pageComponents: [],
  pageComponent: null,

  insertAtIndex: null,

  theme: {
    _id: null,
    fonts: {
      primary: null
    },
    colors: {
      primary: null,
      black: null,
      white: null
    },
    elevation: null,
    roundness: null,
    spacing: null
  },

  integrations: {
    google: {
      webfonts: []
    }
  },

  untouchedState: null
}

export default (state, action) => {
  switch (action.type) {
    case CREATE_PROJECT_STATE:
      if (!action.project) {
        return {
          ...state,
          loading: false,
          notFound: true
        }
      }

      return {
        ...state,
        loading: false,
        project: action.project,
        components: action.components,
        page: action.project.page,
        pageComponents: action.project.page.components.map(pageComponent => ({
          _id: pageComponent._id,
          _cid: pageComponent._id,
          component: pageComponent.component,
          attributes: parseAttributes(pageComponent.attributes),
          attrs: getAttrs(pageComponent.attributes, { parseAttributes: true })
        })),
        theme: {
          _id: action.project.theme._id,
          fonts: {
            primary: action.project.theme.fonts.primary
          },
          colors: {
            primary: action.project.theme.colors.primary,
            black: action.project.theme.colors.black,
            white: action.project.theme.colors.white
          },
          elevation: action.project.theme.elevation,
          roundness: action.project.theme.roundness,
          spacing: action.project.theme.spacing
        },
        integrations: {
          google: {
            webfonts: action.integrations.google.webfonts
          }
        }
      }

    case DESTROY_PROJECT_STATE:
      return {
        ...initialState
      }

    case SET_PROJECT_DEVICE:
      return {
        ...state,
        device: action.device
      }

    case PUBLISH_PROJECT_REQUEST:
      return { ...state, isPublishing: true }

    case PUBLISH_PROJECT_SUCCESS:
      return {
        ...state,
        isPublishing: false,
        isPublishingSuccessful: true
      }

    case PUBLISH_PROJECT_COMPLETE:
      return { ...state, isPublishingSuccessful: false }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project.js